module.exports = __webpack_public_path__ + "img/chev-right-light.ff3bf955.svg";